import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from '@mui/material';
import { NavLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../images/name-removebg-preview.png'; // Ensure this path is correct
import { useTheme } from '@mui/material/styles';

function Navbar() {
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('md'));

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const mobileMenuId = 'primary-search-account-menu-mobile';

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem component={NavLink} to="/" onClick={handleMobileMenuClose} sx={navLinkStyle(isMobileView)}>
        Home
      </MenuItem>
      <MenuItem component={NavLink} to="/about" onClick={handleMobileMenuClose} sx={navLinkStyle(isMobileView)}>
        About
      </MenuItem>
      <MenuItem component={NavLink} to="/Cuisine" onClick={handleMobileMenuClose} sx={navLinkStyle(isMobileView)}>
      Cuisine
      </MenuItem>
      <MenuItem component={NavLink} to="/Trilling" onClick={handleMobileMenuClose} sx={navLinkStyle(isMobileView)}>
      Thrilling
      </MenuItem>
      <MenuItem component={NavLink} to="/contact" onClick={handleMobileMenuClose} sx={navLinkStyle(isMobileView)}>
        Contact
      </MenuItem>
    </Menu>
  );

  return (
    <AppBar
      position="fixed"
      color="transparent"
      elevation={0}
      sx={{
        width: '100%',
        padding: isMobileView ? '0.0001%' : '0.5%',
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(0,0,0,0.2)', // Transparent background
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          flexDirection: isMobileView ? 'row' : 'row',
          alignItems: 'center',
        }}
      >
        {/* Desktop Menu */}
        <Box sx={{ display: { xs: 'none', md: 'flex' },  alignItems: 'center', marginLeft:'20px' }}>
          <Button component={NavLink} to="/" sx={({ isActive }) => (isActive ? activeNavLinkStyle(isMobileView) : navLinkStyle(isMobileView))}>
            Home
          </Button>
          <Button component={NavLink} to="/about" sx={({ isActive }) => (isActive ? activeNavLinkStyle(isMobileView) : navLinkStyle(isMobileView))}>
            About 
          </Button>
          <Button component={NavLink} to="/Cuisine" sx={({ isActive }) => (isActive ? activeNavLinkStyle(isMobileView) : navLinkStyle(isMobileView))}>
          Cuisine
          </Button>
          <Button component={NavLink} to="/Trilling" sx={({ isActive }) => (isActive ? activeNavLinkStyle(isMobileView) : navLinkStyle(isMobileView))}>
          Thrilling
          </Button>
          <Button component={NavLink} to="/contact" sx={({ isActive }) => (isActive ? activeNavLinkStyle(isMobileView) : navLinkStyle(isMobileView))}>
            Contact
          </Button>
         
        </Box>

        {/* Logo and Brand Name with Link to Home Page */}
        <NavLink to="/" style={{ textDecoration: 'none' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                marginRight: 8,
                height: isMobileView ? '20px' : '40px', // Adjust logo size for mobile views
              }}
            />
          </Box>
        </NavLink>

        <Typography
          variant="h6"
          component="a"
          href="tel:+94776718674"
          sx={{
            color: '#ffffff',
            fontWeight: 'bold',
            textDecoration: 'none',
            cursor: 'pointer',
            fontSize:  { xs: 'none', md: '0.8rem' , lg: '1.2rem' },
            display: { xs: 'none', md: 'none' , lg:'block'}, // Hide on small screens, show on medium and larger screens
            '&:hover': {
              color: 'black',
            },
          }}
        >
          +94 776 718 674
        </Typography>


        {/* Book Now Button */}
        <Box sx={{ display: { xs: 'none', md: 'inline-flex' } }}>
          <a href="tel:+94776718674" style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              sx={{
                fontWeight: 'bold',
                padding: '6px 16px',
                backgroundColor: 'transparent', // Transparent background
                color: 'white',
                border: '2px solid #ffffff',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  color: '#ffffff',
                  border: '2px solid white',
                },
                transition: 'all 0.3s ease-in-out',
              }}
            >
              Book Now
            </Button>
          </a>
        </Box>

        {/* Mobile Menu Icon */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, color: 'white' }}>
          <IconButton
            size="large"
            aria-label="show more"
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            onClick={handleMobileMenuOpen}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>
      {renderMobileMenu}
    </AppBar>
  );
}

// Default Navigation Link Styling
const navLinkStyle = (isMobileView) => ({
  color: isMobileView ? '#000000' : '#ffffff',
  fontSize: isMobileView ? '0.8rem' : '1rem', // Responsive font size
  fontWeight: '400',
  textTransform: 'none',
  textDecoration: 'none',  
  '&:hover': {
    color: 'white',
  },
});

// Active Navigation Link Styling
const activeNavLinkStyle = (isMobileView) => ({
  ...navLinkStyle(isMobileView),
  color: '#C8102E',
});

export default Navbar;
